import React from 'react';
import PropTypes from 'prop-types';

export default function Google({ size, display }) {
  return (
    // prettier-ignore
    <svg viewBox="0 0 48 48" width={size} height={size} className={`google-icon display-${display}`}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            d="M44.5,20H24v8.5H35.8C34.7,33.9,30.1,37,24,37a13,13,0,0,1,0-26,12.72,12.72,0,0,1,8.1,2.9l6.4-6.4A22,22,0,1,0,24,46c11,0,21-8,21-22A18.25,18.25,0,0,0,44.5,20Z"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)">
        <path style={{ fill: '#fbbc05' }} d="M0,37V11L17,24Z" />
      </g>
      <g clipPath="url(#clip-path)">
        <path style={{ fill: '#ea4335' }} d="M0,11,17,24l7-6.1L48,14V0H0Z" />
      </g>
      <g clipPath="url(#clip-path)">
        <path style={{ fill: '#34a853' }} d="M0,37,30,14l7.9,1L48,0V48H0Z" />
      </g>
      <g clipPath="url(#clip-path)">
        <path style={{ fill: '#4285f4' }} d="M48,48,17,24l-4-3L48,11Z" />
      </g>
    </svg>
  );
}

Google.propTypes = {
  display: PropTypes.oneOf(['inline', 'block', 'inlineBlock']),
  size: PropTypes.number,
};

Google.defaultProps = {
  size: 26,
  display: 'inlineBlock',
};



// WEBPACK FOOTER //
// ./src/components/icons/Google/index.js